import {SETTINGS} from 'redux/actionTypes';

export const changeTools = (tools) => {
	return (dispatch) => {
		dispatch({
			type: SETTINGS.CHANGE_TOOLS,
			tools
		});
	}
}

export const changeMode = (mode) => {
	return (dispatch) => {
		dispatch({
			type: SETTINGS.CHANGE_MODE,
			mode
		});
	}
}


export const resetMode = (tools) => {
	return (dispatch) => {
		dispatch({
			type: SETTINGS.RESET_MODE
		});
	}
}

export const saveSelection = (selection) => {
	return (dispatch) => {
		dispatch({
			type: SETTINGS.SAVE_SELECTION,
			selection
		});
	}
}
